export const RatePlanApplicationLevelEnum = Object.freeze({
    GROUP: 'GROUP',
    INVESTOR: 'INVESTOR'
});

export default RatePlanApplicationLevelEnum;
